"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardBackground = exports.GridLayout = void 0;
const colors_1 = require("../styles/colors");
exports.GridLayout = {
    styleOverrides: {
        container: {
            backgroundColor: `${colors_1.$primaryWhite}`,
        },
    },
};
exports.CardBackground = {
    styleOverrides: {
        root: {
            backgroundColor: `${colors_1.$primaryWhite}`,
        },
    },
};
